import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const Accordion = dynamic(() => import('./Accordion'));

Builder.registerComponent(Accordion, {
	name: 'Accordion',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: '<h2>Frequently Asked Questions</h2>',
		},
		{
			name: 'tabs',
			friendlyName: 'Tabs',
			type: 'list',
			copyOnAdd: false,
			subFields: [
				{
					name: 'question',
					friendlyName: 'Question',
					type: 'string',
					required: true,
					defaultValue: 'Placeholder Question?',
				},
				{
					name: 'answer',
					friendlyName: 'Answer',
					type: 'richText',
					required: true,
					defaultValue: '<p>Placeholder answer.</p>',
				},
			],
			defaultValue: [
				{
					question: 'Placeholder Question?',
					answer: '<p>Placeholder answer.</p>',
				},
				{
					question: 'Placeholder Question?',
					answer: '<p>Placeholder answer.</p>',
				},
			],
		},
	],
	image: getIconUrl(Icon.ACCORDION),
});
